module.exports = __webpack_public_path__ + "img/Galactapedia_Greycat_Industrial.f0ada13a.png";